<div class="m-utilisateurs">
  <div class="m-utilisateurs__header">
    <app-ui-section-header [title]="'UTILISATEURS.TITLE' | translate" />
    <div class="m-utilisateurs__actions">
      <button
        class="m-utilisateurs__export-btn"
        (click)="exportToCSV()"
        [disabled]="isLoading() || allUtilisateurs().length === 0"
      >
        {{ 'UTILISATEURS.EXPORT_CSV' | translate }}
      </button>
      <button class="m-utilisateurs__refresh-btn" (click)="onRefresh()" [disabled]="isLoading()">
        {{ 'UTILISATEURS.REFRESH' | translate }}
      </button>
    </div>
  </div>

  <div class="m-utilisateurs__search">
    <input
      type="text"
      class="m-utilisateurs__search-input"
      [placeholder]="'UTILISATEURS.SEARCH_EMAIL_PLACEHOLDER' | translate"
      [value]="searchEmail()"
      (input)="onSearchChange($any($event.target).value)"
    />
  </div>

  <div class="m-utilisateurs__content">
    @if (isLoading()) {
      <div class="m-utilisateurs__loading">
        <p>{{ 'COMMON.LOADING' | translate }}</p>
      </div>
    } @else if (error()) {
      <div class="m-utilisateurs__error">
        <p>{{ 'UTILISATEURS.LOAD_ERROR' | translate }}</p>
      </div>
    } @else if (utilisateurs().length === 0) {
      <div class="m-utilisateurs__empty">
        <p>{{ 'UTILISATEURS.NO_USERS' | translate }}</p>
      </div>
    } @else {
      <div class="m-utilisateurs__table-container">
        <table class="m-utilisateurs__table">
          <thead>
            <tr>
              <th>{{ 'UTILISATEURS.MATRIC' | translate }}</th>
              <th>{{ 'UTILISATEURS.EMAIL' | translate }}</th>
              <th>{{ 'UTILISATEURS.FUNCTION_TITLE' | translate }}</th>
              <th>{{ 'UTILISATEURS.LAST_LOGIN' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (user of utilisateurs(); track user.id) {
              <tr>
                <td>{{ user.matric }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.functionTitle }}</td>
                <td></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
